var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "imc_main_modal",
        "no-close-on-backdrop": true,
        modalClass: "modal-alert",
        bodyClass: "p-0",
      },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function ({ close }) {
            return [
              _c("h5", { staticClass: "modal-title" }, [
                _vm._v("\n            " + _vm._s(_vm.title) + "\n        "),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: {
                    type: "button",
                    "data-dismiss": "modal",
                    "aria-label": "Close",
                  },
                  on: {
                    click: function ($event) {
                      return close("no")
                    },
                  },
                },
                [
                  _c("span", { attrs: { "aria-hidden": "true" } }, [
                    _c("i", { staticClass: "fal fa-times" }),
                  ]),
                ]
              ),
            ]
          },
        },
        {
          key: "modal-footer",
          fn: function ({ ok, cancel }) {
            return [
              _vm.show_buttons
                ? _c(
                    "div",
                    { staticClass: "main_burttons" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "shadow-0 mr-2",
                          attrs: { size: "lg", variant: "primary" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.close("ok")
                            },
                          },
                        },
                        [_vm._v("\n                Гаразд\n            ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "shadow-0 mr-2",
                          attrs: { size: "lg", variant: "danger" },
                          on: {
                            click: function ($event) {
                              return _vm.close("no")
                            },
                          },
                        },
                        [_vm._v("\n                Скасувати\n            ")]
                      ),
                    ],
                    1
                  )
                : _c("div", { staticClass: "disable_button" }),
            ]
          },
        },
      ]),
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _vm._v(" "),
      _c("div", { staticClass: "description" }, [
        _vm._v("\n        " + _vm._s(_vm.html) + "\n    "),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }